import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { generateGetTicketV2 } from '../../../../config/endpoints';
import withEndpointAuthorization from '../../authorization/withEndPointAuthorization';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import { GET } from '../../../../config/permissions';

export const TicketDiscountCodeLabel = ({ discountCode }) => (
  <ResourceProperty label="Código de Descuento:">
    {discountCode || '-'}
  </ResourceProperty>
);

TicketDiscountCodeLabel.propTypes = {
  discountCode: PropTypes.isRequired,
};

const connectedComponent = connect(null, null)(TicketDiscountCodeLabel);

export default withEndpointAuthorization({
  url: generateGetTicketV2(0),
  permissionType: GET,
})(connectedComponent);
